module.exports = __webpack_public_path__ + "epdf-app/dashboard/resumption/resumption-modal-lad-specific-16SBci2P.html";